import { OptroAccessListFlagSchema } from "../models/audit/optroAccess";

/**
 * Whether a list page came back with Optro unavailable. A flag that can't be
 * read says so rather than failing the whole page: the rows are already
 * filtered by the backend, the flag only explains what's missing.
 */
export const readOptroAccessUnavailable = (response: unknown): boolean => {
  const parsed = OptroAccessListFlagSchema.safeParse(response);
  return parsed.success ? parsed.data.optroAccessUnavailable : true;
};

/**
 * The list's flag after one more page lands. Rows hidden from an earlier page
 * stay hidden while later pages load, so only a reset (a fresh first page with
 * nothing else kept) can clear it; a load-more or an in-place refresh can only
 * raise it.
 */
export const mergeOptroAccessUnavailable = (
  reset: boolean,
  current: boolean,
  page: boolean,
): boolean => (reset ? page : current || page);
